<template>
  <TermsPage type="industry" name="Industries" :slug="$route.params.slug" />
</template>
